import React from "react"
import styled from "@emotion/styled"
import Image from "../global/Image"

const Container = styled.div`
  align-items: center;
  background-color: ${props => props.theme.shade[90]};
  border-radius: 16px;
  overflow: hidden;
  display: grid;
  grid-auto-flow: row;
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    gap: 32px;
    display: grid;
    grid-auto-flow: dense;
    grid-template-columns: repeat(2, 1fr);
  }
`
const MediaFeatureImage = styled.div`
  width: 100%;
  height: 100%;
  margin-top: auto;
  margin-bottom: auto;
  > * {
    height: 100%;
  }
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    margin-bottom: 16px;
  }
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    grid-column: ${props => (props.reverse ? "1" : "2")};
  }
`
const MediaFeatureText = styled.div`
  width: 100%;
  padding: 96px;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    padding: 32px;
  }
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    grid-column: ${props => (props.reverse ? "2" : "1")};
  }
`

export default function MediaFeatureCard({ reverse, src, alt, children }) {
  return (
    <Container reverse={reverse}>
      <MediaFeatureImage reverse={reverse}>
        <Image src={src} alt={alt} />
      </MediaFeatureImage>
      <MediaFeatureText reverse={reverse}>{children}</MediaFeatureText>
    </Container>
  )
}
